import React from 'react';
import { Paper, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  description: {
    marginBottom: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

interface NoFormsPlaceholderProps {
  onAddNewForm: () => void;
}

/**
 * Placeholder component displayed when no forms are selected
 */
const NoFormsPlaceholder: React.FC<NoFormsPlaceholderProps> = ({ onAddNewForm }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <Typography variant="h6" className={classes.title} gutterBottom>
        No Forms Selected
      </Typography>
      <Typography variant="body1" className={classes.description} paragraph>
        Please search for a claim using the policy number or add a new form.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={onAddNewForm}
        className={classes.button}
      >
        Add New Form
      </Button>
    </Paper>
  );
};

export default NoFormsPlaceholder;
